import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import LandingPage from './pages/LandingPage';
import AgentLandingPage from './pages/AgentLandingPage';
import Login from './pages/backoffice/Login';
import Dashboard from './pages/backoffice/Dashboard';
import Leads from './pages/backoffice/Leads';
import PageEditor from './pages/backoffice/PageEditor';
import SEOEditor from './pages/backoffice/SEOEditor';
import SEOLLMEditor from './pages/backoffice/SEOLLMEditor';
import TrackingEditor from './pages/backoffice/TrackingEditor';
import BrandingEditor from './pages/backoffice/BrandingEditor';
import BackofficeLayout from './components/BackofficeLayout';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/a/:slug" element={<AgentLandingPage />} />
        
        {/* Auth */}
        <Route path="/bo/login" element={<Login />} />
        
        {/* Backoffice (protected) */}
        <Route path="/bo" element={<ProtectedRoute><BackofficeLayout /></ProtectedRoute>}>
          <Route index element={<Navigate to="/bo/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="leads" element={<Leads />} />
          <Route path="page-editor" element={<PageEditor />} />
          <Route path="seo" element={<SEOEditor />} />
          <Route path="tracking" element={<TrackingEditor />} />
          <Route path="branding" element={<BrandingEditor />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
